import React from 'react';
import { injectIntl, IntlShape } from 'react-intl';
import { Grid } from '@material-ui/core';
import { SmallSectionHeader } from 'components/Typography';
import messages from 'containers/AMCDashboard/practicalBlock/messages';
import { translate } from 'helpers/intl';
import PracticalCardButtonList from 'components/PracticalCardButtonList';
import { PracticalData } from './PracticalData';

export interface PracticalDataBlocPropsType {
  intl: IntlShape;
  mdGrid?: any;
  smGrid?: any;
}
const PracticalBlock = (props: PracticalDataBlocPropsType) => {
  return (
    <React.Fragment>
      <Grid container>
        <Grid xs={12} item>
          <SmallSectionHeader>
            {translate({ ...messages.practicalData }, props)}
          </SmallSectionHeader>
          <SmallSectionHeader style={{ color: '#0075C9', fontSize: '14px' }}>
            {translate({ ...messages.procedure }, props)}
          </SmallSectionHeader>
        </Grid>

        <PracticalCardButtonList items={PracticalData} spacing={2} />
      </Grid>
      {/*TODO: uncomment when guide us is ready*/}
      {/* <Grid style={{ paddingTop: '16px' }} container>
        <Grid xs={12} item>
          <SmallSectionHeader style={{ color: '#0075C9', fontSize: '14px' }}>
            {translate({ ...messages.guides }, props)}
          </SmallSectionHeader>
        </Grid>

        <SizedGridItem style={{ marginTop: 0, width: '100%' }} item>
          <ItemWrapper
            style={{
              marginRight: 0,
              marginLeft: 0,
              marginTop: 0,
              justifyContent: 'flex-start',
            }}
            data-testid={`download-file-${1}`}
            onClick={ () => {}}
          >
            <img alt="downloadIcon" src={AssuranceIcon['downloadIcon']} />
            <StyledCaptions reverse={reverse}>
              {props.intl.formatMessage({
                id: 'dashboard_amc.guide.download.button',
              })}
            </StyledCaptions>
          </ItemWrapper>
        </SizedGridItem>
      </Grid> */}
    </React.Fragment>
  );
};

export default injectIntl(PracticalBlock);
